import styled from 'styled-components';
import { H2 } from '../styledComponents1'
import { device } from "../device";


export const FirstScreen = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    width: 100%;

    min-height: 100vh;
    padding: 120px 0 96px;

    color: #fff;

    background: var(--brand);
    
    @media ${device.lg} {
        padding: 152px 0 128px;
    }
`;
export const Main = styled.main`
    flex: 1;
`;
export const H1 = styled.h1`
    margin: 0 0 32px;

    font-size: 32px;
    font-weight: 500;
    line-height: 1.25;
    @media ${device.lg} {
        margin: 0 0 48px;
        font-size: 48px;
        line-height: 1.17;
    }
`;
export const Tagline = styled.div`
    font-size: 14px;
    margin-bottom: 32px;
    @media ${device.lg} {
        margin-bottom: 32px;
    }
`;
export const MostUsed = styled.div``;
export const MostUsedTitle = styled(H2)`
    font-size: 24px;
    @media ${device.lg} {
        font-size: 32px;
    }
`;
export const MostUsedList = styled.ul`
    list-style: none;
    margin: 0;
    padding: 0;
    li {
        max-width: 350px;
        width: 100%;
        &:not(:last-child) {
            border-bottom: 1px solid var(--midle-gray3);
        }
    }
`;
export const DocLink = styled.a`
    align-items: center;
    justify-content: space-between;
    display: flex;
    padding: 16px 0;
    width: 100%;

    color: inherit;

    transition: color .1s ease-in-out;
`;
export const SideBar = styled.aside`
    display: none;
    @media ${device.lg} {
        display: block;
        width: 300px;
    }
    @media ${device.xl} {
        width: 320px;
    }
`;
export const SideMenu = styled.ul`
    li {
        &:not(:last-child) {
            margin-bottom: 16px;
        }
    }
    @media ${device.lg} {
        list-style: none;
        margin: 0;
        padding: 0 24px;
    }
`;
export const MenuLink = styled.a`
    font-size: 18px;
    font-weight: 500;

    color: inherit;
    cursor: pointer;

    transition: color .1s ease-in-out;
`;